// extracted by mini-css-extract-plugin
module.exports = {"article":"styles_article__2H9gX","header":"styles_header__Ud0Xy"};